import { ToggleButton } from '@mui/material';
import { MouseEvent } from 'react';

import { PERIOD_LABEL, PeriodKey } from '../../constants';
import { StyledGroup } from './styles';

const ORDER: PeriodKey[] = ['today', 'month', 'quarter', 'year'];

interface PeriodSelectorProps {
  value: PeriodKey;
  onChange: (next: PeriodKey) => void;
}

export function PeriodSelector({
  value,
  onChange,
}: PeriodSelectorProps): JSX.Element {
  const handle = (
    _e: MouseEvent<HTMLElement>,
    next: PeriodKey | null
  ): void => {
    if (next && next !== value) onChange(next);
  };

  return (
    <StyledGroup
      value={value}
      exclusive
      size="small"
      onChange={handle}
      aria-label="período"
    >
      {ORDER.map((p) => (
        <ToggleButton key={p} value={p} aria-label={PERIOD_LABEL[p]}>
          {PERIOD_LABEL[p]}
        </ToggleButton>
      ))}
    </StyledGroup>
  );
}
